<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="labels" search pagination max-items="15">
      <template slot="header">
        <h3>
          Címkék
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addLabel()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Megnevezés
        </vs-th>
        <vs-th>
          Leírás
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.LabelName }}
          </vs-td>
          <vs-td>
            {{ tr.LabelDescription }}
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="editLabel(tr.Id)"></vs-button>
              <vs-button radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delLabel(tr.Id)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addLabelModal" title="Új címke hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_label v-bind:selected="selected"></new_label>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editLabelModal" title="Címke módosítása" :active.sync="editModal"
                @closemodal="closeModal()">
        <edit_label v-bind:selected="selected"></edit_label>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_label from "../../components/modals/new_label";
import edit_label from "../../components/modals/edit_label";

export default {
  name: "labels",
  data() {
    return {
      labels: [],
      editModal: false,
      addModal: false,
      selected: {
        Id: '',
        LabelName: '',
        LabelDescription: '',
        LabelIcon: ''
      }
    }
  },
  components: {
    new_label, edit_label
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getLabels();
    },
    getLabels() {
      let self = this;
      axiosInstance
          .get('admin/labelController.php', {
            withCredentials: true,
          })
          .then((response) => {
            this.labels = response.data.responseData;
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addLabel() {
      this.selected.LabelName = '';
      this.selected.LabelDescription = '';
      this.selected.LabelIcon = '';
      this.addModal = true;
    },
    editLabel(id) {
      this.selected = {...this.labels.find(elem => elem.Id === id)};
      this.editModal = true;
    },
    delLabel(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja a címkét?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/labelController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.getLabels();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getLabels();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>